import { useEffect, useRef, useState } from 'react';
import { Modal, Button } from '../components/ui';
import { ApiError } from '../services/api';

/** A closed quarter is a business decision; retry only after explicit confirmation. */
export function useClosedQuarterConfirmation() {
  const [open, setOpen] = useState(false);
  const resolver = useRef<((accepted: boolean) => void) | null>(null);
  useEffect(
    () => () => {
      resolver.current?.(false);
    },
    []
  );
  function decide(accepted: boolean) {
    resolver.current?.(accepted);
    resolver.current = null;
    setOpen(false);
  }
  async function run<T>(operation: (confirmed: boolean) => Promise<T>): Promise<T | null> {
    try {
      return await operation(false);
    } catch (error) {
      if (
        !(error instanceof ApiError) ||
        (error.data as { code?: string } | null)?.code !== 'quartal_closed_confirm_required'
      )
        throw error;
      const accepted = await new Promise<boolean>((resolve) => {
        resolver.current = resolve;
        setOpen(true);
      });
      return accepted ? operation(true) : null;
    }
  }
  const dialog = (
    <Modal isOpen={open} onClose={() => decide(false)} title="Abgeschlossenes Quartal" size="md">
      <p className="text-white/70">
        Dieser Beleg gehört zu einem abgeschlossenen Quartal. Soll er als nachträgliche Änderung
        gespeichert werden?
      </p>
      <div className="flex flex-wrap justify-end gap-3 mt-6">
        <Button variant="ghost" onClick={() => decide(false)}>
          Weiter bearbeiten
        </Button>
        <Button onClick={() => decide(true)}>Nachträglich speichern</Button>
      </div>
    </Modal>
  );
  return { run, dialog };
}
